import { render, staticRenderFns } from "./PsiDetailConnectAccounts.vue?vue&type=template&id=9dc0a91a&scoped=true"
import script from "./PsiDetailConnectAccounts.vue?vue&type=script&lang=js"
export * from "./PsiDetailConnectAccounts.vue?vue&type=script&lang=js"
import style0 from "./PsiDetailConnectAccounts.vue?vue&type=style&index=0&id=9dc0a91a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc0a91a",
  null
  
)

export default component.exports